module.exports = __webpack_public_path__ + "img/Pista_09.54fef426.png";